/* Not loaded on the storefront: the theme loads esp-mobile-menu.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in esp-mobile-menu.min.js. */
/* Uses the existing theme popup, menu accordions, finder, and Gorgias integration. */
(() => {
  'use strict';

  if (window.espMobileMenuInitialized) return;
  window.espMobileMenuInitialized = true;
  const mobile = window.matchMedia('(max-width: 991px)');
  let chatReady = false;
  let currentMenu;
  let scheduled = false;
  function syncCategories(menu) {
    menu.querySelectorAll('[data-esp-category-button]').forEach(button => {
      const panel = menu.querySelector(button.dataset.target) || button.dataset.fallbackTarget && menu.querySelector(button.dataset.fallbackTarget);
      button.hidden = !panel;
      const link = button.parentElement.querySelector('[data-esp-category-link]');
      if (link) link.hidden = Boolean(panel);
      if (panel) {
        button.dataset.target = '#' + panel.id;
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', String(panel.classList.contains('active')));
        if (link) linkTitle(panel, link);
      }
    });
  }
  // The row opens the submenu, so a heading with its own page (Replacement Filters) links to it from the submenu's title (LIVE-77).
  function linkTitle(panel, link) {
    const title = panel.querySelector('.mobile-navigation-title span.esp-menu-category-title');
    if (!title) return;
    const anchor = document.createElement('a');
    anchor.className = title.className;
    anchor.href = link.getAttribute('href');
    if (link.hasAttribute('aria-current')) anchor.setAttribute('aria-current', 'page');
    anchor.textContent = title.textContent;
    title.replaceWith(anchor);
  }
  function prepare(menu) {
    const close = menu.querySelector('.esp-menu-header .jsClose');
    const chat = menu.querySelector('.esp-menu-support [data-esp-open-chat]');
    menu.querySelectorAll('.sub-layer').forEach(panel => {
      // These are native accordion indicators, not links to another menu panel.
      panel.querySelectorAll('summary span.jsToggleClass').forEach(indicator => {
        indicator.classList.remove('jsToggleClass');
        indicator.classList.add('esp-menu-accordion-arrow');
        indicator.removeAttribute('data-target');
        indicator.hidden = false;
        indicator.setAttribute('aria-hidden', 'true');
      });
      const body = panel.querySelector('.mobile-navigation-body');
      if (!body || body.querySelector('.esp-menu-subheader')) return;
      const back = body.querySelector(':scope > .mobile-navigation-back');
      const title = body.querySelector(':scope > .mobile-navigation-title');
      if (!back || !title || !close) return;
      const header = document.createElement('div');
      header.className = 'esp-menu-subheader';
      body.prepend(header);
      header.append(back, title, close.cloneNode(true));
      if (chat && !panel.classList.contains('esp-menu-finder-panel')) {
        const support = document.createElement('div');
        support.className = 'esp-menu-panel-chat';
        support.append(chat.cloneNode(true));
        body.append(support);
      }
    });
    prepareFinder(menu, chat);
    syncCategories(menu);
    menu.querySelectorAll('[data-esp-open-chat]').forEach(button => button.hidden = !chatReady);
  }
  function prepareFinder(menu, chat) {
    const finder = menu.querySelector('.esp-menu-finder-panel filter-manuals');
    if (!finder || finder.dataset.espPrepared) return;
    finder.dataset.espPrepared = 'true';
    const model = finder.querySelector('[data-field-index="3"]');
    const summary = model.querySelector('summary');
    const title = summary.querySelector('.js-title');
    const submit = finder.querySelector('.js-btn-submit span');
    submit.textContent = 'Find My Replacements';
    if (chat) {
      const help = chat.cloneNode(true);
      help.className = 'esp-finder-help';
      help.textContent = 'Can’t find your model?';
      finder.querySelector('.chosen-btn').after(help);
    }
    const updateModel = () => {
      const hasBrand = Boolean(finder.querySelector('[data-field-index="2"] .finder-choice.active'));
      const disabled = String(!hasBrand);
      if (summary.getAttribute('aria-disabled') !== disabled) summary.setAttribute('aria-disabled', disabled);
      if (!hasBrand) {
        model.open = false;
        if (title.textContent !== 'Select a brand first') title.textContent = 'Select a brand first';
        if (summary.getAttribute('aria-label') !== 'Model: Select a brand first') summary.setAttribute('aria-label', 'Model: Select a brand first');
      }
    };
    const preventDisabled = event => {
      if (summary.getAttribute('aria-disabled') === 'true' && (event.type === 'click' || ['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    summary.addEventListener('click', preventDisabled, true);
    summary.addEventListener('keydown', preventDisabled, true);
    new MutationObserver(updateModel).observe(finder, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    updateModel();
  }
  function sync() {
    scheduled = false;
    const menu = document.querySelector('popup-component.esp-mobile-menu');
    if (menu) {
      prepare(menu);
      if (menu !== currentMenu) {
        currentMenu = menu;
        new MutationObserver(schedule).observe(menu, {
          attributes: true,
          attributeFilter: ['aria-hidden', 'class'],
          childList: true,
          subtree: true
        });
      }
    }
    const open = mobile.matches && (menu === null || menu === void 0 ? void 0 : menu.getAttribute('aria-hidden')) === 'false';
    document.body.classList.toggle('esp-menu-is-open', Boolean(open));
    updateObstruction();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function updateObstruction() {
    let clearance = 0;
    if (mobile.matches) {
      document.querySelectorAll('sticky-mobile-bar, [role="dialog"], iframe').forEach(element => {
        if (element.closest('#mobileMenu, #gorgias-chat-container')) return;
        if (element.tagName === 'IFRAME' && !/preview|cookie|privacy/i.test(element.id + ' ' + element.title)) return;
        const style = getComputedStyle(element);
        if (!['fixed', 'sticky'].includes(style.position) || style.visibility === 'hidden' || style.display === 'none') return;
        const rect = element.getBoundingClientRect();
        if (rect.height > 0 && rect.height < innerHeight * 0.45 && rect.width > innerWidth * 0.6 && rect.bottom >= innerHeight - 4 && rect.top < innerHeight) {
          clearance = Math.max(clearance, innerHeight - Math.max(0, rect.top));
        }
      });
    }
    const value = Math.ceil(clearance) + 'px';
    if (document.documentElement.style.getPropertyValue('--esp-chat-obstruction') !== value) {
      document.documentElement.style.setProperty('--esp-chat-obstruction', value);
    }
  }
  function readyChat() {
    if (!window.GorgiasChat) return;
    Promise.resolve(window.GorgiasChat.init()).then(() => {
      chatReady = true;
      schedule();
    }).catch(() => {/* Contact and phone remain available when chat cannot load. */});
  }
  window.addEventListener('gorgias-widget-loaded', readyChat);
  readyChat();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-esp-open-chat]');
    if (!button || !chatReady) return;
    event.preventDefault();
    const menu = button.closest('popup-component');
    if (typeof (menu === null || menu === void 0 ? void 0 : menu.close) === 'function') menu.close();
    document.body.classList.remove('esp-menu-is-open');
    window.GorgiasChat.open();
  });
  mobile.addEventListener('change', () => {
    var _currentMenu, _currentMenu$close, _currentMenu2;
    if (!mobile.matches && ((_currentMenu = currentMenu) === null || _currentMenu === void 0 ? void 0 : _currentMenu.getAttribute('aria-hidden')) === 'false') (_currentMenu$close = (_currentMenu2 = currentMenu).close) === null || _currentMenu$close === void 0 || _currentMenu$close.call(_currentMenu2);
    schedule();
  });
  window.addEventListener('resize', schedule, {
    passive: true
  });
  window.addEventListener('scroll', updateObstruction, {
    passive: true
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => {
      var _node$matches, _node$querySelector;
      return node.nodeType === 1 && (((_node$matches = node.matches) === null || _node$matches === void 0 ? void 0 : _node$matches.call(node, 'popup-component.esp-mobile-menu, #gorgias-chat-container, iframe, [role="dialog"]')) || ((_node$querySelector = node.querySelector) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.call(node, 'popup-component.esp-mobile-menu, #gorgias-chat-container, iframe, [role="dialog"]')));
    }))) schedule();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
  schedule();
})();
